import httpClient from '../../services/http-client';
import { API_SUB_URL_DEPARTMENT } from '../../constants';
import { fetchDataRequest, fetchDataSuccess, fetchDataError } from '../actions';
import { 
    FETCH_DATA_REQUEST, FETCH_DATA_ERROR,
    ADD_NEW_DEPARTMENT, LOAD_LIST_DEPARTMENT, LOAD_A_DEPARTMENT, UPDATE_A_DEPARTMENT, DELETE_A_DEPARTMENT
} from '../actionTypes';

export const apiLoadListDepartment = (params) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        let query = "";

        Object.keys(params).map(key => {
            if(params[key]) {
                query += (query.length > 0 ? "&&" : "") + (`${key}=` + params[key]);
            }
        });

        httpClient.get(`${API_SUB_URL_DEPARTMENT}?${query}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_LIST_DEPARTMENT, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiLoadADepartment = ({ id }) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.get(`${API_SUB_URL_DEPARTMENT}/${id}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_A_DEPARTMENT, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiCreateNewDepartment = (payload) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.post(API_SUB_URL_DEPARTMENT, payload)
            .then(response => {
                dispatch(fetchDataSuccess(ADD_NEW_DEPARTMENT, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiUpdateADepartment = ({id, payload}) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.put(`${API_SUB_URL_DEPARTMENT}/${id}`, payload)
            .then(response => {
                dispatch(fetchDataSuccess(UPDATE_A_DEPARTMENT, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiDeleteADepartment = ({id, payload}) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.delete(`${API_SUB_URL_DEPARTMENT}/${id}`, payload)
            .then(response => {
                dispatch(fetchDataSuccess(DELETE_A_DEPARTMENT, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};